/**
 * admin/students.tsx — Admin siswa management page.
 *
 * Lives at `/admin/students`. Auth-gated to admins. Renders PageHeader +
 * <SiswaListPanel> (Fase 2 N-09, extended 2026-07-17). Admin can:
 *   - lihat siswa yang sudah bergabung (filter by status, search, pagination)
 *   - tambah siswa secara manual lewat form (tanpa kode undangan)
 *   - nonaktifkan / aktifkan kembali siswa (toggle is_active)
 *   - buka drawer detail untuk ringkasan progres + kelas yang diikuti
 *
 * Invite-code flow tetap tersedia untuk tutor yang ingin menambah siswa
 * dari sisi kelas; admin tidak lagi harus minta tutor minting invite untuk
 * onboarding satu siswa.
 */

import type { ReactNode } from 'react';
import { createFileRoute, redirect } from '@tanstack/react-router';
import { PageHeader } from '../../components/ui/PageHeader.js';
import SiswaListPanel from '../../components/admin/SiswaListPanel.js';
import { freshSessionQuery, siswaListQuery } from '../../lib/api/queries.js';

export const Route = createFileRoute('/admin/students')({
  beforeLoad: async ({ context, location }) => {
    const session = await context.queryClient.fetchQuery(freshSessionQuery);
    const user = session?.ok ? (session.data?.user ?? null) : null;
    if (!user) {
      throw redirect({
        to: '/login',
        search: { error: undefined, redirect: location.href },
      });
    }
    if (user.role !== 'admin') {
      throw redirect({ to: '/' });
    }
    return null;
  },
  loader: async ({ context }) => {
    await context.queryClient.prefetchQuery(siswaListQuery({ page: 1, limit: 20 }));
    return null;
  },
  component: AdminStudentsPage,
});

function AdminStudentsPage(): ReactNode {
  return (
    <main className="page-shell">
      <PageHeader
        eyebrow="Operasional"
        title="Manajemen siswa"
        description="Tambah siswa baru, lihat daftar siswa yang sudah bergabung, dan nonaktifkan akun bila diperlukan. Siswa juga bisa bergabung lewat kode undangan dari tutor."
      />
      <section className="section is-flush">
        <SiswaListPanel />
      </section>
    </main>
  );
}
